import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { AutoCropDirective } from './directives/auto-crop-image.directive';
import { BarcodeDirective } from './directives/barcode.directive';
import { MaterialModule } from './material.module';
import { FilePreviewPipe } from './pipes/file-preview.pipe';
import { RentalDurationPipe } from './pipes/rental-duration.pipe';
import { TitleCaseKeyPipe } from './pipes/title-case-key.pipe';
import { UtcToLocalDatePipeOnly } from './pipes/utc-to-local-date-only.pipe';
import { UtcToLocalDatePipe } from './pipes/utc-to-local-date.pipe';
import { UtcToLocalTimePipe } from './pipes/utc-to-local-time.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgbModule,
    BarcodeDirective,
    TitleCaseKeyPipe,
    RentalDurationPipe,
    UtcToLocalDatePipe,
    UtcToLocalDatePipeOnly,
    UtcToLocalTimePipe,
    FilePreviewPipe,
    AutoCropDirective,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgbModule,
    BarcodeDirective,
    TitleCaseKeyPipe,
    RentalDurationPipe,
    UtcToLocalDatePipe,
    UtcToLocalDatePipeOnly,
    UtcToLocalTimePipe,
    FilePreviewPipe,
    AutoCropDirective,
  ],
  providers: [],
})
export class SharedModule {}
